import { IS_PROD_APP_ENV } from 'Utilities/constants';

export const zendeskRetry = (cb) => setTimeout(cb, 500);

export const zeKey = (IS_PROD_APP_ENV)
  ? 'd5e79e18-889b-41cf-b200-1bb7535acc66'
  : 'ceb69e8d-3e65-44aa-9f25-ecf7133c75f1';

export const zendeskSnowplowSessionFieldId = (IS_PROD_APP_ENV)
  ? '13689725328668'
  : '18308472438173';

export const zendeskSessionFieldId = (IS_PROD_APP_ENV)
  ? '14978453258652'
  : '19489983432605';

export const ZENDESK_CONVERSATION_KEYS = {
  GET_SUPPORT: 'GET_SUPPORT',
};

export const ZENDESK_CONVERSATION_TYPES = {
  [ZENDESK_CONVERSATION_KEYS.GET_SUPPORT]: 'get-support',
};

export const ZENDESK_CONVERSATION_FIELD_IDS = {
  GET_SUPPORT: (IS_PROD_APP_ENV)
    ? '18955703038364'
    : '25160041033757',
};
